export default {
  active: 'Active',
  activeOnly: 'Active only',
  activateCitrixMetaframeXPLicenses: 'Activate Citrix MetaFrame XP licenses',
  activity: 'Activity',
  activityLog: 'Activity log',
  addLicense: 'Add license to my account',
  all: 'All',
  allActive: 'All active',
  allArchived: 'All hidden',
  allLicenses: 'All licenses',
  allocateAvailablelicenses: 'Allocate available licenses',
  allocateConfirmation: 'Is this correct?',
  allocateConfirmationInfo: 'Allocate <b>{remainingCount}</b> {license} to host: <b>{hostValue}</b>',
  allocateConfirmationNo: 'No, modify the allocation',
  allocateConfirmationYes: 'Yes, create license file',
  allocateConfirmationLoadingHeader: 'Generating license file.',
  allocateConfirmationLoadingInfo: 'This could take a minute or two, please be patient.',
  allocated: 'Allocated',
  allocateDownload: 'Your new license file is ready for download.',
  allocateDownloadInfo: 'Install this license file on host: <b>{hostValue}</b>.',
  allocateFailCtaButtonText: 'Download completed licenses',
  allocateFailSecondaryButtonText: 'Download list (.txt) of failed licenses',
  allocateLicense: 'Allocate license',
  allocateLicenses: 'Allocate licenses',
  allocateMoreLicenses: 'Allocate more licenses',
  allocateNow: 'Allocate now',
  allocationHelp: 'Allocation help',
  allocations: 'Allocations',
  any: 'Any',
  archive: 'Archive',
  archiveLicenses: 'Hide licenses',
  available: 'Available',
  availableAllocations: 'Available allocations',
  bulkActionCtaButtonText: 'Keep selection, stay on page',
  bulkActionErrorInfo: '<p>You can apply bulk actions only to multiple items on a single page.</p><p>If you continue to the next page, selected items are deselected.</p>',
  bulkActionErrorTitle: 'One page at a time.',
  bulkActions: 'Bulk actions',
  bulkActionSecondaryButtonText: 'Deselect all and continue to next page',
  by: 'By',
  cancel: 'Cancel',
  clearSearch: 'Clear search',
  closeAndChange: 'Close and change selection',
  closeWindow: 'Close window',
  contactCitrix: 'Customer Care contact details:\r\nEmail: support@citrix.com\r\nPhone - US: 800-000-0000',
  contactCustomerService: 'Contact Customer Service',
  continue: 'Continue',
  createLicenseFile: 'Create license file',
  date: 'Date',
  dateRange: 'Date range',
  day: '1 day | {count} days',
  deleteAllNotes: 'Delete all notes',
  didYouKnow: 'Did you know...',
  didYouKnowContent: '...XenApp and XenDesktop are now Citrix Virtual Apps and Desktops?',
  download: 'Download',
  downloadLicenseFiles: 'Download license file | Download license files ',
  dontSeeLicenses: "Don't see a new license?",
  surveyLicense: 'Tell us how we are doing?',
  easyAllocation: 'Easy allocation',
  easyAnswer1: 'To see all licenses or perform a download, return, or modification of other licenses sign in to your account.',
  easyAnswer2: "See the <a id='link' target='_blank' href='{citrixLicensingDocumentationUrl}'>Citrix Licensing documentation</a>. For more detailed information about licensing your specific Citrix products, see the product's administrator documentation at <a id='link' target='_blank' href='{docsUrl}'>https://docs.citrix.com/</a>.",
  easyQuestion1: 'How do I find licenses from a different order?',
  easyQuestion2: 'How do I learn more about Citrix Licensing?',
  email: 'Email',
  enterHostName: 'Enter host name',
  enterIpAddress: 'Enter IP address',
  enterMacAddress: 'Enter MAC address',
  ethernet: 'Ethernet',
  expirationDate: 'Expiration date',
  enterLicenseCode: 'Enter license code',
  expires: 'Expires',
  expiring: '(Expiring) | Expiring',
  expiredActivationLink: 'The activation link has expired.\n\nTo proceed with the easy allocation of your purchased licenses, please click here to Resend Email',
  expiringInfo: "Once the expiration date passes, these licenses do not work on your server nor appear in your list of licenses. If you need assistance with expired licenses, contact <a id='link' href='{customerServiceUrl}' target='_blank'>Customer Service</a>.",
  expiringLicenses: 'Expiring Licenses',
  expiringMaintenance: 'expiring maintenance',
  expiringTermLicenses: 'Expiring term licenses',
  exportList: 'Export list (.CSV)',
  exportToExcel: 'Export to Excel (.CSV)',
  failDataErrorDescription: "We are unable to complete your request online. Contact <a id='link' href='{customerServiceUrl}' target='_blank'>Citrix Customer Care</a> to resolve the issue.",
  failDataErrorTitle: 'We ran into a problem.',
  failSystemErrorDescription: "<p>We encountered an issue generating your licenses. Try again later.</p><p>If the issue persists, contact <a id='link' href='{customerServiceUrl}' target='_blank'>Citrix Customer Care</a>.",
  failSystemErrorTitle: 'There was a system error on our end.',
  filterBy: 'Filter by',
  findLicenseBy: 'Find a license by...',
  from: 'From',
  fullAllocationMessage: 'You must allocate this license in full.',
  fullModificationMessage: 'You must modify this license in full.',
  help: 'help | Help',
  hidden: 'Hidden',
  hiddenLicenseEmptyStateMessage: 'To perform any action on this license, please unhide the license.',
  hiddenOnly: 'Hidden only',
  hide: 'Hide | hide',
  hideAdvancedSearchOptions: 'Hide advanced search options',
  hideLicensesModalDescription: 'You will need to unhide these licenses to make them available for allocation in the future.',
  hideUnhideLicenses: '{typeText} licenses',
  hideUnhideLicensesModalTitle: 'Are you sure you want to {typeText} {count} {license}?',
  host: 'Host',
  hostId: 'Host ID | host ID',
  hostIdAsc: 'Host ID (A-Z)',
  hostIdDesc: 'Host ID (Z-A)',
  hostname: 'Host name',
  hostnameInfo: '<b class="danger-text">IMPORTANT</b>: Host names are caSe SenSitive',
  internet: 'Internet',
  invalidAllocateCount: 'You must allocate at least 1 license OR use the Return allocation action.',
  invalidAllocateCountNonNumeric: 'Only numbers allowed.',
  invalidAllocateCountExcessCount: 'You may only allocate up to {count} licenses.',
  invalidEmailFormat: 'Email format is invalid',
  invalidHostTypeMessage: "You've entered an invalid {hostType}.",
  invalidModifyCount: 'You must modify at least 1 license OR use the Return allocation action.',
  invalidModifyCountExcessCount: 'You may only modify up to {count} licenses.',
  invalidWebkey: 'Oops! Seems like you have entered incorrect web key. Please try again.',
  ipAddress: 'IP Address',
  itemsCount: 'showing {number} of {total}',
  last30Days: '(last 30 days)',
  learnMore: 'Learn more',
  license: 'license',
  licenseAccessCode: 'License access code',
  licenseAllocationTextPrefix: 'You have {available} of {total} {license} available for allocation.',
  licenseAllocationTextSuffix: 'Click "Allocate licenses" to begin allocating your licenses now.',
  licenseAsc: 'License (A-Z)',
  licenseCreation: 'License creation',
  licenseCode: 'License code',
  licenseDesc: 'License (Z-A)',
  licenseDetail: 'License detail',
  licenseFile: 'License file',
  licenseFullyAllocated: 'License already fully allocated.',
  licenseOrSerialNumber: 'License/serial number',
  licenses: 'Licenses | licenses',
  licensingFaqs: 'Licensing FAQs',
  licensingSurveyHeader: 'Tell us how we are doing?',
  licensingSurveyBody: 'Kindly provide your feedback on the new Licensing Tool.',
  lineItemNumber: 'Line item number',
  locateAMissingLicense: 'Associate a new license code to your account',
  loginId: 'Login ID',
  loginPrompt: 'Please enter the Login ID of the customer below and click on Continue',
  macAddress: 'MAC Address',
  manageLicenses: 'Manage licenses',
  missingLicenseHelpText: 'Some types of licenses must be allocated before they are associated to your account. Enter your license code below to allocate a license now.',
  modify: 'Modify',
  modifyAllocations: 'Modify allocations',
  modifyDownload: 'Your modified license file is ready for download.',
  modifyDownloadInfo: 'Remove existing license file from host: <b>{hostValue}</b>.',
  modifyLicenseFile: 'Modify license file',
  modifyMoreLicenses: 'Modify more licenses',
  multipleSelectionAllocateErrorTitle: 'One or more licenses are fully allocated.',
  multipleSelectionAllocateErrorDescription: '<p>You can apply allocations only to items with available allocations.</p><p>If you continue, any fully allocated licenses are ignored.</p>',
  multipleSelectionErrorModalButtonText: '{action} allocated licenses',
  multipleSelectionHostTypeError: 'To apply a bulk action, all items must match your first selection of host type={hostType}',
  futureDateLicenseError: 'You can allocate and download licenses with a future start date. They\'re unusable until the start date-{StartDate}',
  multipleSelectionOtherErrorTitle: 'One or more licenses are not allocated.',
  multipleSelectionOtherErrorDescription: '<p>You can only apply this action to items that have been allocated.</p><p>If you continue, any licenses that have not been allocated are ignored.</p>',
  name: 'Name',
  new: '(New)',
  newestFirst: 'Newest first',
  newLicenses: 'New Licenses',
  no: 'No',
  noExpiringLicensesBody: 'You have no expiring maintenance agreements that require your attention.',
  noExpiringLicensesTitle: 'No expiring maintenance',
  noLicenseActivityBody: 'You have no recent purchases or expiring maintenance agreements that require your attention.',
  noLicenseActivityTitle: 'No pending activity',
  noNewPurchasesBody: 'You have no recent purchases that require your attention.',
  noNewPurchasesTitle: 'No recent purchases',
  noRecordsFound: 'No matching records found',
  noSelectionInfoText: 'Please select at least one license from the list below.',
  notApplicable: 'Not applicable',
  notAvailable: 'Not available',
  notes: 'Notes',
  number: 'Number',
  oldestFirst: 'Oldest first',
  orderDate: 'Order date',
  orderDetails: 'Order details',
  orderNumber: 'Order number | Order Number',
  paginationPrevText: 'Prev',
  paginationNextText: 'Next',
  productAsc: 'Product (A-Z)',
  productDesc: 'Product (Z-A)',
  productName: 'Product name',
  purchased: 'Purchased',
  purchasedBy: 'Purchased by',
  purchaseDate: 'Purchase date',
  quantity: 'Quantity',
  quickFind: 'Quick find',
  recentPurchases: 'recent purchases | Recent Purchases',
  reenterCode: 'Re-enter code',
  reloadPage: 'reload this page.',
  renewLicenses: 'Renew licenses in DOTI | Renew licenses',
  renewMyLicenses: 'Renew my licenses',
  renewalHelp: 'Expiring term license help',
  resendEmail: 'To proceed with the easy allocation of your purchased licenses, please click here to ',
  resendEmailLinkText: 'Resend Email',
  resendEmailFailureMessage: 'Email Address or License Access Code you entered is incorrect. Please check the License delivery notification email for details.',
  resendEmailSuccessMessage: 'Email has been resent successfully. Please request the recipient to check their inbox.',
  resendEmailTitle: 'Resend email with Easy Allocation Link',
  resendEmailExternalMessage: 'Thank you, you will receive an email shortly. Note: If you do not receive an email, please re-verify the email address and the license access code in the license delivery notification email and try again or contact customer service for further assistance.',
  return: 'Return',
  returnAllocations: 'Return allocations',
  returnAllLicenses: 'Return all licenses',
  returnConfirmation: 'Are you sure you want to return {count} {license} from host: <b>{hostIds}</b>?',
  returnConfirmationFinalInfo: '{count} allocations have been returned and are available for reuse.',
  returnConfirmationFinalTitle: 'Remove existing license file on host: <b>{hostValue}</b>.',
  returnConfirmationInfo: 'This action cannot be undone.',
  returnConfirmationLoadingHeader: 'Returning selected license now.',
  returnNo: 'No, cancel return',
  returnYes: 'Yes, process return',
  saveNote: 'Save note',
  search: 'Search',
  selectAnAction: 'Select an action',
  show: 'Show',
  showAdvancedSearchOptions: 'Show advanced search options',
  showing: 'showing {number} of {total}',
  signInToMyAccount: 'Sign in to manage licenses',
  somethingWentWrong: 'Something went wrong on our side',
  somethingWentWrongInfo: 'Server encountered an error while processing the <b>{text}</b> request.<br />',
  sortBy: 'Sort by',
  submit: 'Submit',
  submitting: 'Submitting',
  to: 'To',
  today: 'Today',
  trialLicenses: 'Trial Licenses',
  tryAgainLater: 'Please try again later or',
  unallocatedLicenses: '{count} {license} not allocated',
  unarchive: 'Unarchive',
  undoArchive: 'Undo hide',
  undoArchiveLicenses: 'Unhide licenses',
  unhide: 'Unhide | unhide',
  unhideLicensesModalDescription: 'Your unhide action will make these licenses available for future action',
  view: 'View',
  viewAllExpiringTermLicense: 'View all expiring term licenses',
  viewAllLicenses: 'View all licenses',
  viewAllNewPurchases: 'View all new purchases',
  viewHideOptions: '{action} options',
  viewPendingHardwareReturns: 'View pending hardware returns',
  personNotFoundError: 'Invalid Username',
  referCustomerCare: 'Refer to this list when speaking to Customer Care',
  unableToAllocatePrefix: 'We were unable to complete your request for the following items:',
  unableToAllocateSuffix: 'We apologies for any inconvenience this may have caused. Our Customer Care experts will assist you to resolve the issue as quickly as possible.',
  upgradeMyLicenses: 'Upgrade my licenses',
  webkeyAllocate: 'This license code will be associated to your account after you allocate it.',
  webkeyInvalid: "The license code entered is invalid. Try re-entering the code. If the problem persists, contact <a id='link' href='{customerServiceUrl}' target='_blank'>Customer Service</a> for assistance.",
  webkeyRegistered: "The license code entered is already associated to an account. If you still do not see it listed in your account, contact <a id='link' href='{customerServiceUrl}' target='_blank'>Customer Service</a> for assistance.",
  yes: 'Yes',
  contactCustomerCareReturn: 'The ability to "Return" and "Modify" licenses is no longer available. For more information <a id="link">click here</a>',
  contactCustomerCareReturnInternal: 'Security changes have been implemented for this tool and only Customer service team were granted access. If your access has been revoked, please create a ticket by clicking here and add a note to assign this ticket to the Customer Service team.',
  otherReason: 'Other Reason',
  selectReason: 'Select a Reason',
  returnReasonOption1: 'Retire/Decommission license server',
  returnReasonOption2: 'Changed license allocation quantity',
  returnReasonOption3: 'Mistyped hostname or host ID',
  returnReasonOption4: 'Technical issues on the Citrix portal',
  returnReasonOption5: 'Server renamed or replaced',
  returnReasonOption6: 'Incorrect expiration date',
  returnReasonOption7: 'Contract allows for rehosting',
  returnReasonOptionOther: 'Other with free form text',
  returnRenameReason: "If the reason you have given is that the current hostname is incorrect or outdated for certain licenses, the new hostname provided for those licenses must not match the hostname or server to which they are currently allocated. If requesting to modify a license matching the hostname which they are currently allocated, use the redownload option. <a id='link' target='_blank' href='{warningLicenseRehostLink}'>Click here</a> for more information",
  modifyReasonOption1: 'Mistyped hostname or host ID',
  modifyReasonOption2: 'Technical issues on the Citrix portal',
  modifyReasonOption3: 'Server renamed or replaced',
  modifyReasonOption4: 'Incorrect expiration date',
  modifyReasonOption5: 'Contract allows for rehosting',
  modifyReasonOptionOther: 'Other with free form text',
  eformlegalTextCheck: "By checking this box, I undertake, on behalf of the license owner, to promptly destroy   Returned or Modified licenses  and all copies thereof. I acknowledge that licenses may only be loaded on a single license server, appliance or instance in accordance with the <a id='link' target='_blank' href='{endUserLicenseAgreement}'>Citrix End User License Agreement</a> (EULA), unless otherwise agreed between Citrix and the license owner in writing, I confirm that the information provided in this form is true and accurate and that I am authorized to submit this form and to provide these undertakings on behalf of the license owner. I understand that Citrix reserves its rights generally including under the EULA and its <a id='link' target='_blank' href='{rightToAuditCompliance}'>right to audit compliance</a>. I agree that Citrix may contact me at the email address provided in this form to confirm its accuracy and to obtain further information regarding this request.",
  rehostLegalText: "PLEASE READ CAREFULLY BEFORE DOWNLOADING THIS FILE.<br />By downloading this file, I undertake, on behalf of the license owner, to promptly destroy Modified licenses and all copies thereof. I acknowledge that licenses may only be loaded on a single license server, appliance or instance in accordance with the <a id='link' target='_blank' href='{endUserLicenseAgreement}'>Citrix End User License Agreement</a> (EULA), unless otherwise agreed between Citrix and the license owner in writing. I understand that Citrix reserves its rights generally including under the EULA and its <a id='link' target='_blank' href='{rightToAuditCompliance}'>right to audit compliance</a>.",
  addDomainsForStrongNetwork: 'Add domains for strong network',
  enterDomainName: 'Enter Domain Name',
  addDomain: 'Add Domain',
  submitDomainFailureMessage: 'Domain registration failed',
  submitDomainSuccessMessage: 'Domains registered successfully.',
  addUniconCustomer: 'Add Unicon Customer',
  enterFirstName: 'Enter first name',
  enterLastName: 'Enter last name',
  enterEmail: 'Enter Email',
  ActivateCustomer: 'Activate Customer',
  ManageLicensesUnicon: 'Manage Licenses - Unicon',
  submitUserFailureMessage: 'User registration failed',
  submitUserSuccessMessage: 'User registered successfully.',
  FirstName: 'First Name',
  LastName: 'Last Name',
  Email: 'Email'
}



// WEBPACK FOOTER //
// ./src/i18n/en.js